import { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { mockVendors } from '../data/mockVendors'
import { mockReviews } from '../data/mockReviews'
import VendorTypeBadges from '../components/VendorTypeBadges'

export default function Home() {
  const [activeTab, setActiveTab] = useState('vendors')
  const [currentTime, setCurrentTime] = useState(new Date())
  const [activeUsers, setActiveUsers] = useState(247)
  const [todaysReviews, setTodaysReviews] = useState(12)

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date())
      // Simulate fluctuating active users
      setActiveUsers(prev => prev + Math.floor(Math.random() * 10) - 5)
      // Simulate new reviews
      if (Math.random() < 0.1) {
        setTodaysReviews(prev => prev + 1)
      }
    }, 30000)

    return () => clearInterval(timer)
  }, [])
  
  // Data preparation
  const topRatedVendors = [...mockVendors]
    .sort((a, b) => b.rating - a.rating)
    .slice(0, 3)

  const recentReviews = [...mockReviews]
    .sort((a, b) => new Date(b.dateCreated).getTime() - new Date(a.dateCreated).getTime())
    .slice(0, 3)

  const featuredReviews = mockReviews
    .filter(review => review.helpfulVotes > 5) // Simulate trusted tester criteria
    .sort((a, b) => b.helpfulVotes - a.helpfulVotes)
    .slice(0, 3)

  const hot7ohProducts = mockVendors
    .flatMap(vendor => 
      vendor.products?.filter(product => 
        product.extractType?.includes('7OH') || product.name.toLowerCase().includes('7oh')
      ).map(product => ({ ...product, vendor })) || []
    )
    .slice(0, 3)

  const communityPosts = [
    { id: 1, title: "Best 7OH brands for beginners?", author: "KratomNewbie", replies: 12, time: "2 hours ago" },
    { id: 2, title: "MIT vs 7OH - Which hits harder?", author: "VeteranUser", replies: 8, time: "4 hours ago" },
    { id: 3, title: "Vendor ABC quality drop?", author: "RegularCustomer", replies: 23, time: "6 hours ago" }
  ]

  const newsItems = [
    { id: 1, title: "New lab testing requirements announced", time: "1 day ago", type: "regulatory" },
    { id: 2, title: "Vendor XYZ achieves ISO certification", time: "2 days ago", type: "vendor" },
    { id: 3, title: "7OH research study published", time: "3 days ago", type: "research" },
    { id: 4, title: "Community milestone: 10K reviews!", time: "5 days ago", type: "community" }
  ]

  const totalReviews = mockReviews.length
  const averageRating = (mockReviews.reduce((sum, review) => sum + review.rating, 0) / totalReviews).toFixed(1)

  return (
    <div className="home-page">
      {/* Logo/Title Section */}
      <div className="page-header">
        <h1>Unbiased Kratom</h1>
      </div>

      {/* Compact Hero Section */}
      <section className="hero-compact">
        <div className="hero-content">
          <p className="hero-subtitle">
            Your trusted hub for honest kratom vendor reviews and community insights
          </p>
          <div className="hero-stats">
            <div className="hero-stat">
              <span className="hero-stat-number">{mockVendors.length}</span>
              <span className="hero-stat-label">Vendors</span>
            </div>
            <div className="hero-stat">
              <span className="hero-stat-number">{totalReviews}</span>
              <span className="hero-stat-label">Reviews</span>
            </div>
            <div className="hero-stat">
              <span className="hero-stat-number">{averageRating}</span>
              <span className="hero-stat-label">Avg Rating</span>
            </div>
            <div className="hero-stat">
              <span className="hero-stat-number">Live</span>
              <span className="hero-stat-label">Activity</span>
            </div>
          </div>
        </div>
      </section>

      {/* Live Price Ticker Widget */}
      <div className="price-ticker">
        <div className="ticker-content">
          <div className="ticker-header">
            <span className="deals-icon">🔥</span>
            <span className="deals-title">DEALS</span>
            <span className="deals-live">LIVE</span>
          </div>
          <div className="ticker-scroll-container">
            <div className="ticker-scroll">
              <span className="price-item">GreenLeaf Co. - 7OH Tabs 20% OFF • </span>
              <span className="price-item">KratomPlus - Free shipping over $75 • </span>
              <span className="price-item">PureExtract - MIT powder $12/g • </span>
              <span className="price-item">LeafyVendor - New batch Red Bali $8/oz • </span>
              <span className="price-item">QualityKratom - Lab verified 99.5% purity • </span>
              <span className="price-item">BotanicalBliss - 30% off all extracts • </span>
              <span className="price-item">NaturalLeaf - Buy 2 get 1 FREE samples • </span>
              <span className="price-item">KratomKings - 7OH extract $15/g flash sale • </span>
              <span className="price-item">PremiumPlants - Red Maeng Da $6/oz • </span>
              <span className="price-item">HerbalHeaven - New customer 25% OFF • </span>
              <span className="price-item">LeafLife - MIT 45% extract $18/g • </span>
              <span className="price-item">GreenGold - White Borneo bulk pricing • </span>
              <span className="price-item">PlantPower - Same day shipping available • </span>
              <span className="price-item">KratomCo - Yellow Vietnam $7/oz limited • </span>
            </div>
          </div>
        </div>
      </div>

      {/* Live Lab Results Widget */}
      <div className="lab-results-ticker">
        <div className="lab-ticker-header">
          <span className="lab-icon">🔬</span>
          <span className="lab-title">LATEST LAB RESULTS</span>
          <span className="lab-live">LIVE</span>
        </div>
        <div className="lab-scroll">
          <div className="lab-item">
            <span className="vendor-name">GreenLeaf Co.</span>
            <span className="batch-id">Batch #GL2024-156</span>
            <span className="purity">99.2% Purity</span>
            <span className="status verified">✓ VERIFIED</span>
          </div>
          <div className="lab-item">
            <span className="vendor-name">KratomPlus</span>
            <span className="batch-id">Batch #KP-7OH-089</span>
            <span className="purity">98.7% Purity</span>
            <span className="status verified">✓ VERIFIED</span>
          </div>
          <div className="lab-item">
            <span className="vendor-name">PureExtract</span>
            <span className="batch-id">Batch #PE-MIT-234</span>
            <span className="purity">45.3% MIT</span>
            <span className="status verified">✓ VERIFIED</span>
          </div>
        </div>
      </div>


      {/* Main Dashboard Grid */}
      <section className="dashboard-grid">
        {/* Left Column - Tabbed Widget */}
        <div className="dashboard-left">
          <div className="tab-widget">
            <div className="tab-nav">
              <button 
                className={`tab-btn ${activeTab === 'vendors' ? 'active' : ''}`}
                onClick={() => setActiveTab('vendors')}
              >
                Top Vendors
              </button>
              <button 
                className={`tab-btn ${activeTab === '7oh' ? 'active' : ''}`}
                onClick={() => setActiveTab('7oh')}
              >
                Hot 7OH
              </button>
              <button 
                className={`tab-btn ${activeTab === 'community' ? 'active' : ''}`}
                onClick={() => setActiveTab('community')}
              >
                Community
              </button>
            </div>
            
            <div className="tab-content">
              {activeTab === 'vendors' && (
                <div className="vendors-list">
                  {topRatedVendors.map((vendor, index) => (
                    <div key={vendor.id} className="vendor-item">
                      <div className="vendor-rank">#{index + 1}</div>
                      <div className="vendor-info">
                        <Link to={`/vendor/${vendor.id}`} className="vendor-name">
                          {vendor.name}
                          {vendor.verified && <span className="verified-mini">✓</span>}
                        </Link>
                        <div className="vendor-rating">
                          <span className="rating">
                            {'★'.repeat(Math.floor(vendor.rating))}
                            {vendor.rating % 1 >= 0.5 ? '✩' : ''}
                            {'☆'.repeat(5 - Math.ceil(vendor.rating))}
                          </span>
                          <span className="rating-text">{vendor.rating}/5</span>
                          <span className="reviews">({vendor.reviewCount})</span>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
              
              {activeTab === '7oh' && (
                <div className="products-list">
                  {hot7ohProducts.map((product, index) => (
                    <div key={`${product.vendor.id}-${product.id}`} className="product-item">
                      <div className="product-info">
                        <Link to={`/vendor/${product.vendor.id}/product/${product.id}`} className="product-name">
                          {product.name}
                        </Link>
                        <div className="product-vendor">{product.vendor.name}</div>
                        <div className="product-price">${product.price}</div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
              
              {activeTab === 'community' && (
                <div className="community-list">
                  {communityPosts.map((post) => (
                    <div key={post.id} className="community-item">
                      <div className="post-info">
                        <Link to={`/community/thread/${post.id}`} className="post-title">
                          {post.title}
                        </Link>
                        <div className="post-meta">
                          <span className="author">{post.author}</span>
                          <span className="replies">{post.replies} replies</span>
                          <span className="time">{post.time}</span>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
          <Link 
            to={activeTab === 'community' ? '/social' : '/vendors'} 
            className="view-more-btn"
          >
            {activeTab === 'community' ? 'View The Community →' : 'View All Vendors →'}
          </Link>
        </div>
        
        {/* Center Column - Featured Reviews */}
        <div className="dashboard-center">
          <div className="featured-reviews-section">
            <div className="section-header-main">
              <h2>🏆 Trusted Tester Reviews</h2>
              <p>Expert reviews from verified community testers</p>
            </div>
            <div className="featured-reviews-layout">
              {featuredReviews.length > 0 && (
                <div className="featured-review-large">
                  {(() => {
                    const review = featuredReviews[0]
                    const vendor = mockVendors.find(v => v.id === review.vendorId)
                    return (
                      <div className="review-header-main">
                        <div className="review-rating-main">
                          <span className="rating-display-main">
                            {'★'.repeat(Math.floor(review.rating))}
                            {review.rating % 1 >= 0.5 ? '✩' : ''}
                            {'☆'.repeat(5 - Math.ceil(review.rating))}
                          </span>
                        </div>
                        <div className="trusted-badge">TRUSTED</div>
                      </div>
                    )
                  })()}
                  <h3 className="review-title-main">{featuredReviews[0].title}</h3>
                  <p className="review-content-main">{featuredReviews[0].content.slice(0, 140)}...</p>
                  <div className="review-footer-main">
                    <span className="reviewer-main">By {featuredReviews[0].userName}</span>
                    {mockVendors.find(v => v.id === featuredReviews[0].vendorId) && (
                      <span className="vendor-name-main">• {mockVendors.find(v => v.id === featuredReviews[0].vendorId)?.name}</span>
                    )}
                    <span className="helpful-count">👍 {featuredReviews[0].helpfulVotes}</span>
                  </div>
                </div>
              )}
              
              {featuredReviews.length > 1 && (
                <div className="featured-reviews-small-grid">
                  {featuredReviews.slice(1, 3).map((review) => {
                    const vendor = mockVendors.find(v => v.id === review.vendorId)
                    return (
                      <div key={review.id} className="featured-review-small">
                        <div className="review-header-small">
                          <div className="review-rating-small">
                            <span className="rating-display-small">
                              {'★'.repeat(Math.floor(review.rating))}
                              {review.rating % 1 >= 0.5 ? '✩' : ''}
                              {'☆'.repeat(5 - Math.ceil(review.rating))}
                            </span>
                          </div>
                          <div className="trusted-badge-small">TRUSTED</div>
                        </div>
                        <h4 className="review-title-small">{review.title}</h4>
                        <p className="review-content-small">{review.content.slice(0, 80)}...</p>
                        <div className="review-footer-small">
                          <span className="reviewer-small">By {review.userName}</span>
                          <span className="helpful-count-small">👍 {review.helpfulVotes}</span>
                        </div>
                      </div>
                    )
                  })}
                </div>
              )}
            </div>
            <Link to="/reviews" className="view-more-btn reviews-btn">View All Trusted Reviews →</Link>
          </div>
        </div>
        
        {/* Right Column - Latest News */}
        <div className="dashboard-right">
          <div className="news-section-main">
            <div className="section-header-main">
              <h2>📰 Latest News</h2>
              <p>Platform updates and industry news</p>
            </div>
            <div className="news-list-main">
              {newsItems.map((item) => (
                <div key={item.id} className="news-item-main">
                  <div className="news-type-main">{item.type}</div>
                  <div className="news-title-main">{item.title}</div>
                  <div className="news-time-main">{item.time}</div>
                </div>
              ))}
            </div>
            <Link to="/news" className="view-more-btn news-btn">View All News →</Link>
          </div>
        </div>
      </section>

      {/* Expanded Tools and Effects Section */}
      <div className="tools-and-effects-section">
        <div className="tools-row">
          <div className="tool-widget-large">
            <div className="tool-header">
              <span className="tool-icon">⚖️</span>
              <h3>Compare Vendors</h3>
            </div>
            <div className="compare-inputs">
              <div className="compare-inputs-row">
                <input type="text" placeholder="First vendor name..." className="tool-input-large" />
                <span className="vs-text">VS</span>
                <input type="text" placeholder="Second vendor name..." className="tool-input-large" />
              </div>
              <button className="tool-action-btn">Compare</button>
            </div>
            <div className="tool-footer">Compare pricing, quality, shipping speed & lab results</div>
          </div>
          
          <div className="tool-widget-large">
            <div className="tool-header">
              <span className="tool-icon">🔬</span>
              <h3>Lab Batch Lookup</h3>
            </div>
            <div className="lookup-inputs">
              <input type="text" placeholder="Enter batch number (e.g. GL2024-156)" className="tool-input-large" />
              <button className="tool-action-btn">Verify</button>
            </div>
            <div className="tool-footer">Verify authenticity and view complete lab analysis</div>
          </div>
          
          <div className="tool-widget-large">
            <div className="tool-header">
              <span className="tool-icon">🧮</span>
              <h3>Dosage Calculator</h3>
            </div>
            <div className="dosage-inputs">
              <select className="tool-select-large">
                <option>7OH Extract</option>
                <option>MIT Extract</option>
                <option>Traditional Leaf</option>
              </select>
              <input type="number" placeholder="Body weight (lbs)" className="tool-input-large" />
              <button className="tool-action-btn">Calculate</button>
            </div>
            <div className="tool-footer">Safe dosing recommendations based on extract type & weight</div>
          </div>
          
          <div className="tool-widget-large">
            <div className="tool-header">
              <span className="tool-icon">📊</span>
              <h3>Price Alert Setup</h3>
            </div>
            <div className="alert-inputs">
              <input type="text" placeholder="Vendor or product name..." className="tool-input-large" />
              <input type="number" placeholder="Target price $" className="tool-input-large" />
              <button className="tool-action-btn">Set Alert</button>
            </div>
            <div className="tool-footer">Get notified when prices drop below your target</div>
          </div>
          
          {/* Interactive Strain Effects Chart - Now Inline */}
          <div className="strain-effects-widget tool-widget-large">
            <div className="tool-header">
              <span className="tool-icon">🌿</span>
              <h3>Live Strain Effects Map</h3>
            </div>
            <div className="effects-grid">
              <div className="effect-bar">
                <span className="effect-name">Energy</span>
                <div className="effect-meter">
                  <div className="effect-fill" style={{width: '78%'}}></div>
                </div>
                <span className="effect-percent">78%</span>
              </div>
              <div className="effect-bar">
                <span className="effect-name">Pain Relief</span>
                <div className="effect-meter">
                  <div className="effect-fill" style={{width: '92%'}}></div>
                </div>
                <span className="effect-percent">92%</span>
              </div>
              <div className="effect-bar">
                <span className="effect-name">Relaxation</span>
                <div className="effect-meter">
                  <div className="effect-fill" style={{width: '65%'}}></div>
                </div>
                <span className="effect-percent">65%</span>
              </div>
              <div className="effect-bar">
                <span className="effect-name">Focus</span>
                <div className="effect-meter">
                  <div className="effect-fill" style={{width: '71%'}}></div>
                </div>
                <span className="effect-percent">71%</span>
              </div>
            </div>
            <div className="tool-footer">Real-time data from 2,341 user reports</div>
          </div>
        </div>
        
        {/* Live Activity Stats - Now on the Right */}
        <div className="activity-stats-widget">
          <h3>📊 Live Activity</h3>
          <div className="stats-grid">
            <div className="stat-item pulse">
              <div className="stat-number">{activeUsers}</div>
              <div className="stat-label">Users Online</div>
              <div className="stat-indicator"></div>
            </div>
            <div className="stat-item">
              <div className="stat-number">{todaysReviews}</div>
              <div className="stat-label">Reviews Today</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">6</div>
              <div className="stat-label">New Lab Results</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">23</div>
              <div className="stat-label">Vendors Active</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">89%</div>
              <div className="stat-label">Platform Health</div>
            </div>
          </div>
        </div>
      </div>

      {/* Quick Filters & Trending */}
      <section className="quick-access">
        <div className="quick-container">
          {/* Quick Filters */}
          <div className="quick-filters">
            <h3>🔍 Quick Filters</h3>
            <div className="filter-tags">
              <Link to="/vendors?filter=fast-shipping" className="filter-tag">⚡ Fast Shipping</Link>
              <Link to="/vendors?filter=lab-tested" className="filter-tag">🔬 Lab Tested</Link>
              <Link to="/vendors?filter=budget-friendly" className="filter-tag">💰 Budget Friendly</Link>
              <Link to="/vendors?filter=premium" className="filter-tag">👑 Premium</Link>
              <Link to="/vendors?filter=7oh" className="filter-tag">🧪 7OH Products</Link>
              <Link to="/vendors?filter=traditional" className="filter-tag">🌿 Traditional Leaf</Link>
              <Link to="/vendors?filter=extracts" className="filter-tag">💧 Extracts</Link>
              <Link to="/vendors?filter=new-vendors" className="filter-tag">🆕 New Vendors</Link>
            </div>
          </div>

          {/* Trending Topics */}
          <div className="trending-topics">
            <h3>🔥 Trending Now</h3>
            <div className="trending-list">
              <div className="trending-item">
                <span className="trend-topic">New lab testing requirements</span>
                <span className="trend-count">234 discussions</span>
              </div>
              <div className="trending-item">
                <span className="trend-topic">7OH vs MIT comparison</span>
                <span className="trend-count">156 discussions</span>
              </div>
              <div className="trending-item">
                <span className="trend-topic">Vendor ABC quality issues</span>
                <span className="trend-count">89 discussions</span>
              </div>
              <div className="trending-item">
                <span className="trend-topic">Best beginner strains</span>
                <span className="trend-count">78 discussions</span>
              </div>
              <div className="trending-item">
                <span className="trend-topic">Bulk buying guides</span>
                <span className="trend-count">67 discussions</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Compact Vendor Status Strip */}
      <div className="vendor-status-strip">
        <div className="status-item">
          <span className="vendor-dot online"></span>
          <span className="vendor-text">GreenLeaf Co.</span>
          <span className="status-text">Online • New stock</span>
        </div>
        <div className="status-item">
          <span className="vendor-dot online"></span>
          <span className="vendor-text">KratomPlus</span>
          <span className="status-text">Online • Lab results posted</span>
        </div>
        <div className="status-item">
          <span className="vendor-dot busy"></span>
          <span className="vendor-text">PureExtract</span>
          <span className="status-text">Processing orders</span>
        </div>
        <div className="status-item">
          <span className="vendor-dot online"></span>
          <span className="vendor-text">LeafyVendor</span>
          <span className="status-text">Online • Sale active</span>
        </div>
      </div>


      {/* Community Reviews Section */}
      <section className="community-reviews">
        <div className="section-header">
          <h2>Community Reviews</h2>
          <p>Latest reviews from our kratom community members</p>
        </div>
        <div className="reviews-grid">
          {recentReviews.map((review) => {
            const vendor = mockVendors.find(v => v.id === review.vendorId)
            return (
              <div key={review.id} className="community-review-card">
                <div className="review-header">
                  <div className="review-rating">
                    <span className="rating-display">
                      {'★'.repeat(Math.floor(review.rating))}
                      {review.rating % 1 >= 0.5 ? '✩' : ''}
                      {'☆'.repeat(5 - Math.ceil(review.rating))}
                    </span>
                  </div>
                  <span className="review-date">
                    {review.dateCreated.toLocaleDateString()}
                  </span>
                </div>
                <h4 className="review-title">{review.title}</h4>
                <p className="review-content">{review.content.slice(0, 150)}...</p>
                <div className="review-footer">
                  <span className="reviewer">By {review.userName}</span>
                  {vendor && <span className="vendor-name">for {vendor.name}</span>}
                </div>
              </div>
            )
          })}
        </div>
        <div className="section-footer">
          <Link to="/reviews" className="view-all-link">
            View All Community Reviews →
          </Link>
        </div>
      </section>

      {/* Info Section */}
      <section className="info-section">
        <div className="info-grid">
          <div className="info-card">
            <div className="info-icon">🏪</div>
            <h3>Verified Vendors</h3>
            <p>
              We carefully vet our vendor partners to ensure quality and reliability. 
              Look for the verified badge for added confidence.
            </p>
          </div>
          <div className="info-card">
            <div className="info-icon">⭐</div>
            <h3>Community Reviews</h3>
            <p>
              Real reviews from real kratom users. Our community-driven approach 
              ensures honest and helpful vendor feedback.
            </p>
          </div>
          <div className="info-card">
            <div className="info-icon">🔍</div>
            <h3>Easy Discovery</h3>
            <p>
              Filter and search vendors by location, specialties, ratings, and more. 
              Find the perfect vendor for your kratom needs.
            </p>
          </div>
        </div>
      </section>
    </div>
  )
}